import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Button, Grid, Paper, Typography } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import LoadingComponent from '../../../components/ui-widgets/LoadingComponent'
import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { selectSettlementProjectId, setSettlementProjectId } from './editPortfoliosSlice'
import {
  useGetSettlementPortfolioProjectQuery
} from '../../../../api-services/asset-holdings/portfolioSettlementsApi'
import { useParams } from 'react-router'
import EditSettlementProjectForm from './EditSettlementProjectForm'
import Refresh from '@mui/icons-material/Refresh'

const SettlementProjectPage: React.FC = () => {
  const params = useParams<any>()
  const history = useHistory()
  const dispatch = useAppDispatch()

  const currentSettlementProjectId: number = useAppSelector<number>(selectSettlementProjectId)
  let projectSettlementId: number = 0

  // ================================================================================================================
  // Initialise params
  if (Boolean(params.projectSettlementId) && projectSettlementId === 0) {
    projectSettlementId = params.projectSettlementId
  }

  const getSettlementProjectApiResult = useGetSettlementPortfolioProjectQuery({ portfolioSettlementProjectId: projectSettlementId })
  const refetchSettlementProject = getSettlementProjectApiResult.refetch
  // const [apiRefundSettlementProjectTrigger, refundApiCallResult] = useRefundSettlementPortfolioProjectMutation()

  // ================================================================================================================
  // Mutation API call result handling

  useEffect(() => {
    if (currentSettlementProjectId !== projectSettlementId) {
      dispatch(setSettlementProjectId(projectSettlementId))
    }
  }, [getSettlementProjectApiResult.isSuccess])

  // useEffect(() => {
  //   if (refundApiCallResult.isSuccess) {
  //     dispatch(setNotification({ open: true, severity: 'success', message: 'The Portfolio Settlement Project refunds have been created, check back in a few minutes...' }))
  //   }
  //
  //   if (refundApiCallResult.isError) {
  //     dispatch(setNotification({
  //       open: true,
  //       severity: 'error',
  //       message: RtkQueryHelper.mapResponseError(refundApiCallResult.error)
  //     }))
  //   }
  // }, [
  //   refundApiCallResult.isSuccess, refundApiCallResult.isError
  // ])

  // ================================================================================================================

  const goTo = (location: string): void => {
    history.push(location)
  }

  const handleRefetch = async (): Promise<void> => {
    await refetchSettlementProject()
  }

  // const isCreateRefundsDisabled = (): boolean => {
  //   if (getSettlementProjectApiResult.isSuccess) {
  //     return getSettlementProjectApiResult.data.status !== 'PENDING'
  //   }
  //   return true
  // }
  //
  // const handleRefund = async (): Promise<void> => {
  //   await apiRefundSettlementProjectTrigger({ portfolioSettlementProjectId: currentSettlementProjectId })
  // }
  //
  return (
    <>
      {getSettlementProjectApiResult.isLoading && <LoadingComponent />}
      {(getSettlementProjectApiResult.error != null) &&
          <ErrorComponent message={RtkQueryHelper.mapResponseError(getSettlementProjectApiResult.error)} />}
      {getSettlementProjectApiResult.isSuccess && (
        <>
          <Box sx={{ mb: 4, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Typography variant={'h5'}>[{getSettlementProjectApiResult.data.projectId}] {getSettlementProjectApiResult.data.projectName} - Settlement Portfolio Project ({getSettlementProjectApiResult.data.portfolioSettlementProjectId})</Typography>
            <Button variant={'text'} type='button' onClick={() => {
              goTo(`/app/finance-area/settlements/${getSettlementProjectApiResult.data.portfolioSettlementId}/edit`)
            }}>
              <ArrowBackIosIcon />
            </Button>
          </Box>

          <Paper>
            <Box sx={{ p: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Grid container>
                <Grid item md={6}>
                </Grid>
                <Grid item md={6} sx={{ textAlign: 'right' }}>
                  <Button variant={'contained'} type="button" onClick={handleRefetch}>
                    <Refresh/>
                  </Button>

                </Grid>
              </Grid>

            </Box>

            <Box sx={{ p: 2, mt: -2 }}>
              <EditSettlementProjectForm settlementProject={getSettlementProjectApiResult.data}
                                         triggerRefetch={handleRefetch} />
            </Box>
          </Paper>
        </>
      )}
    </>
  )
}

export default SettlementProjectPage
